import config from 'config';
import API from 'services/AUTH_API';

export default function login(data, ESAuth = false) {
  const clientId = ESAuth ? config.ESAuthClientId : config.clientId;
  const clientSecret = ESAuth ? config.ESAuthClientSecret : config.clientSecret;
  data.append('grant_type', 'password');
  data.append('client_id', clientId);
  data.append('client_secret', clientSecret);

  return API.request({
    method: 'POST',
    url: `/oauth/token`,
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
